export default __webpack_public_path__ + "static/media/search.a2d2f0eb.svg";